/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Swift_Eagle_SoarInputs */

const en_bold_swift_eagle_soar = /** @type {(inputs: Bold_Swift_Eagle_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export as PowerPoint`)
};

const de_bold_swift_eagle_soar = /** @type {(inputs: Bold_Swift_Eagle_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als PowerPoint exportieren`)
};

/**
* | output |
* | --- |
* | "Export as PowerPoint" |
*
* @param {Bold_Swift_Eagle_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_swift_eagle_soar = /** @type {((inputs?: Bold_Swift_Eagle_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Swift_Eagle_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_swift_eagle_soar(inputs)
	return de_bold_swift_eagle_soar(inputs)
});